import { PaymentContainer, Translator, Alert } from '@itarget/shared'
import {
  Box,
  Breadcrumbs,
  Button,
  CircularProgress,
  Container,
  Dialog,
  DialogActions,
  DialogTitle,
  Divider,
  Grid,
  Icon,
  Link,
  Typography,
} from '@material-ui/core'
import CardShopping from '../../../components/CardShopping'
import CardToPayment from '../../../components/CardToPayment'
import CardWrongCreditCard from '../../../components/CardWrongCreditCard'
import Layout from '../../../components/Layout'
import Loading from '../../../components/Loading'
import './style.scss'
import { makeStyles } from '@material-ui/styles'
import CashbackWallet from '../../../components/CashbackWallet'
import { ModalQuestions } from '../../../components/ModalQuestionsCourse'
import TimerShoppingCart from '../TimerShoppingCart'

const useStyles = makeStyles((theme) => ({
  shoppingCartIcon: {
    fontSize: '1.6rem !important',
  },
  shoppingCartItemsContainer: {
    display: 'flex',
    gap: theme.spacing(2),
    flexDirection: 'column',
  },
}))

const ShoppingCartView = ({
  alert,
  isLoading,
  activityChecked,
  vlTotal,
  incList,
  goFinish,
  courses = [],
  selected,
  setSelected = {},
  total,
  onChangeSelected,
  state,
  setState,
  toast,
  paymentRedux,
  paymentType,
  fetchInscricoes,
  subscriptionState,
  totalState,
  subscription,
  user,
  center_cost_id,
  openConfirmUnsubscribe,
  handleCloseUnsubscribe,
  onClickUnsubscribe,
  openModal,
  onInvalidCardPayment,
  showWrongCard,
  resetStatePayment,
  setShowWrongCard,
  changePayment,
  settingCommerce,
  dispatch,
  amountProduct,
  goTo,
  setShowQuiz,
  showQuiz,
  setting,
  authRedux,
  cashbackWalletBalanceUsed,
  handleApplyCashbackWallet,
  handleCleanAppliedCashbackWallet,
  canUseCashbackWallet,
  cashbackWalletLimitRedemption,
  userCashbackBalance,
  cashbackSymbol,
}) => {
  const styles = useStyles()
  return (
    <Layout isLoading={isLoading}>
      <Dialog
        className={'dialog-unsubscribe'}
        open={openConfirmUnsubscribe}
        onClose={handleCloseUnsubscribe}
      >
        <DialogTitle id="alert-dialog-title">
          <Translator
            transRef={'translation.Deseja cancelar a sua inscrição?'}
          />
        </DialogTitle>
        <DialogActions>
          <Button onClick={handleCloseUnsubscribe}>
            <Translator transRef={'translation.Voltar'} />
          </Button>
          <Button onClick={onClickUnsubscribe} autoFocus>
            <Translator transRef={'translation.Cancelar inscrição'} />
          </Button>
        </DialogActions>
      </Dialog>
      <Box>
        <Breadcrumbs style={{ marginTop: 15, padding: 8 }} separator=">">
          {[
            <div
              key={'offers-page'}
              onClick={() => goTo('')}
              onKeyDown={() => goTo('')}
              style={{ cursor: 'pointer', fontWeight: 'bold' }}
            >
              <Translator transRef="translation.Ofertas" />
            </div>,
            <div key={'current-shopping-cart-page'} style={{ fontSize: 12 }}>
              <Translator transRef="translation.Carrinho de compras" />
            </div>,
          ]}
        </Breadcrumbs>
      </Box>
      <Container maxWidth="xl" className="shoppingCart-header">
        {showWrongCard && (
          <CardWrongCreditCard
            changePayment={changePayment}
            setShow={setShowWrongCard}
          />
        )}
        <Grid container alignItems="left" spacing={1}>
          <Grid item>
            <Icon className={styles.shoppingCartIcon}>shopping_cart</Icon>
          </Grid>
          <Grid item>
            <Typography variant="h5">
              <Translator transRef={'translation.Carrinho'} />
            </Typography>
          </Grid>
        </Grid>
        <TimerShoppingCart standardTime={60} />
      </Container>
      <Divider />
      {showQuiz && (
        <ModalQuestions
          setShowQuiz={() => {
            setShowQuiz()
          }}
          questionDestination={17}
          centerCostId={center_cost_id}
        />
      )}
      <Grid container spacing={5} className="shoppingCart-body">
        <Grid item xs={12} md={9} className={styles.shoppingCartItemsContainer}>
          {isLoading && (
            <Box width="100%" alignItems="center" justifyContent="center">
              <Loading />
            </Box>
          )}
          {!isLoading && courses?.length < 1 && (
            <Grid item container>
              <Typography variant="h5" className="title">
                <Translator transRef={'translation.Seu carrinho está vazio.'} />
              </Typography>
            </Grid>
          )}
          {['payment', 'voucher'].includes(state) && (
            <Grid container item className="grid-cardPayment">
              <PaymentContainer
                settingCommerce={settingCommerce}
                subscription={subscription}
                goFinish={goFinish}
                centro_custo_id={center_cost_id}
                toast={toast}
                paymentType={paymentType}
                subscriptionState={subscriptionState}
                paymentRedux={paymentRedux}
                total={totalState}
                user={user}
                onInvalidCardPayment={onInvalidCardPayment}
                resetState={resetStatePayment}
                authRedux={authRedux}
                cashbackWalletBalanceUsed={cashbackWalletBalanceUsed}
              />
            </Grid>
          )}
          {state === 'cards' &&
            courses.map((row) => (
              <Grid
                key={`aga.id=${row.agenda_atividade_id}_plp.id=${row.conta_receber_id}`}
                className="grid-cardPayment"
              >
                <CardToPayment
                  activityChecked={activityChecked}
                  openModal={openModal}
                  openConfirmUnsubscribe={openConfirmUnsubscribe}
                  handleCloseUnsubscribe={handleCloseUnsubscribe}
                  onClickUnsubscribe={onClickUnsubscribe}
                  onChange={onChangeSelected}
                  card={row}
                  courses={courses}
                  settingCommerce={settingCommerce}
                />
              </Grid>
            ))}
        </Grid>
        <Grid item xs={12} md={3} className="gridItem-detailPurchase">
          <Grid className="grid-detailPurchase">
            {state === 'finish' ? (
              <>
                <Typography className="header">
                  <Translator transRef={'translation.Ações'} />
                </Typography>
                <Typography className="link-finish">
                  <Link onClick={() => goTo('my-activity#3')}>
                    <Translator transRef={'translation.Acessar meus cursos'} />
                  </Link>
                </Typography>
                <Typography className="link-finish">
                  <Link href="/shopping-cart">
                    <Translator transRef={'translation.Ir para Carrinho'} />
                  </Link>
                </Typography>
                <Typography className="link-finish">
                  <Link href="/">
                    <Translator transRef={'translation.Continuar comprando'} />
                  </Link>
                </Typography>
              </>
            ) : (
              <>
                {canUseCashbackWallet && (
                  <>
                    {alert.open && (
                      <Alert.Root marginBottom={2}>
                        <Alert.Container>
                          <Alert.Title icon="lock">
                            <Translator transRef="translation.Programa cashback bloqueado" />
                          </Alert.Title>
                          <Alert.Content>{alert.message}</Alert.Content>
                        </Alert.Container>
                      </Alert.Root>
                    )}
                    {!alert.open && (
                      <CashbackWallet
                        cashbackSymbol={cashbackSymbol}
                        balance={userCashbackBalance}
                        balanceUsed={cashbackWalletBalanceUsed}
                        onApplyCashback={handleApplyCashbackWallet}
                        totalToSpend={cashbackWalletLimitRedemption}
                        handleCleanAppliedCashbackWallet={
                          handleCleanAppliedCashbackWallet
                        }
                      />
                    )}
                  </>
                )}

                <CardShopping
                  fetchInscricoes={fetchInscricoes}
                  total={total}
                  state={state}
                  setState={setState}
                  selected={selected}
                  setSelected={setSelected}
                  user={user}
                  dispatch={dispatch}
                  amountProduct={amountProduct}
                  courses={courses}
                  setting={setting}
                  appliedCashbackWallet={cashbackWalletBalanceUsed}
                  handleCleanAppliedCashbackWallet={
                    handleCleanAppliedCashbackWallet
                  }
                />
              </>
            )}
          </Grid>
        </Grid>
      </Grid>
    </Layout>
  )
}

export default ShoppingCartView
